<div class="row mb-48">
    <div class="col-xs-12 col-md-10 tabs is-center mb-40">
        <ul [class.list-equal]="isMobile$ | async">
            <li [ngClass]="{ 'is-active': (type$ | async) === OrderTypeEnum.ONLINE }">
                <a [routerLink]="['../online']">{{ 'dev.myAccount.menu.orders.online' | translate }}</a>
            </li>
            <li [ngClass]="{ 'is-active': (type$ | async) === OrderTypeEnum.STORE }">
                <a [routerLink]="['../store']">{{ 'dev.myAccount.menu.orders.shop' | translate }}</a>
            </li>
        </ul>
    </div>

    <div class="col-xs-10 mb-24">
        <h4 class="title-l-b ttu">{{ 'dev.myAccount.menu.orders' | translate }}</h4>
    </div>

    <div *ngIf="(showVideoRefund$ | async) && (returnsVideoUrl$ | async) && (type$ | async) === OrderTypeEnum.ONLINE" class="col-xs-10 mb-16">
        <p class="text-m" [ngClass]="{ 'text-center': isMobile }">
            {{ 'dev.myAccount.refundVideo.description' | translate }}
            <a (click)="goToReturnsVideo()" class="link-line text-l">{{ 'dev.myAccount.refundVideo.link' | translate }}</a>
        </p>
    </div>

    <ng-container *ngIf="(type$ | async) === OrderTypeEnum.ONLINE && ordersOnline$ | async as ordersOnline">
        <ng-container *ngIf="ordersOnline.length; else emptyOrders">
            <div
                class="col-xs-12 col-md-9"
                infiniteScroll
                [infiniteScrollDistance]="paginationOptions.scrollDistance"
                [infiniteScrollUpDistance]="paginationOptions.scrollUpDistance"
                [infiniteScrollThrottle]="paginationOptions.throttle"
                [infiniteScrollDisabled]="(hasMore$ | async) === false"
                (scrolled)="handleScroll()"
            >
                <div *ngFor="let order of ordersOnline" class="mb-16">
                    <item-order [order]="order"></item-order>
                </div>
            </div>
            <div class="hidden-md col-lg-1"></div>
            <div class="hidden-xs col-md-3 col-lg-2" *ngIf="showMultiDevo$ | async">
                <button class="btn btn-primary btn--full" (click)="goReturn()">
                    <span>{{ 'dev.myAccount.returns.multiorder.button' | translate }}</span>
                </button>
            </div>
            <div class="hidden-md hidden-lg hidden-xl floating-button w-100 p-16 bg-white" *ngIf="showMultiDevo$ | async">
                <button class="btn btn-primary btn--full" (click)="goReturn()">
                    <span>{{ 'dev.myAccount.returns.multiorder.button' | translate }}</span>
                </button>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="(type$ | async) === OrderTypeEnum.STORE && ordersStore$ | async as ordersStore">
        <ng-container *ngIf="ordersStore.length; else emptyOrders">
            <div
                class="col-xs-12 col-md-10"
                infiniteScroll
                [infiniteScrollDistance]="paginationOptions.scrollDistance"
                [infiniteScrollUpDistance]="paginationOptions.scrollUpDistance"
                [infiniteScrollThrottle]="paginationOptions.throttle"
                [infiniteScrollDisabled]="(hasMore$ | async) === false"
                (scrolled)="handleScroll()"
            >
                <div *ngFor="let order of ordersStore" class="mb-16">
                    <item-order [order]="order"></item-order>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
<ng-template #emptyOrders>
    <div class="col-xs-12 align-center my-48">
        <svg-icon src="order" class="mb-8"></svg-icon>
        <span>{{ 'legacy.common.emptyOrders' | translate }}</span>
    </div>
</ng-template>
